<script>
import { CountTo } from "vue3-count-to";
import Lottie from "@/components/widgets/lottie";
import animationData from "@/components/widgets/msoeawqm.json";

export default {
  props:['prospectsList'],
  components: {
    CountTo,
    Lottie,
  },
  data(){
    return{
      defaultOptions: { animationData: animationData },
    }
  },
  computed: {
    firstRow() {
      const mid = Math.ceil(this.prospectsList[0]?.length / 2);
      return this.prospectsList[0]?.slice(0, mid) || [];
    },
    secondRow() {
      const mid = Math.ceil(this.prospectsList[0]?.length / 2);
      return this.prospectsList[0]?.slice(mid) || [];
    }
  }


};
</script>
<style>
.crm-widget .col {
  border-right: 3px solid #e9ebec !important;
}

.crm-widget .col:last-child {
  border: 0px !important;
}

[data-layout-mode="light"] .custom-card-border {
  border-color: #6c757d !important;
}
</style>
<template>
  <div class="container-fluid px-2">
    <h2 class="my-3 text-center text-md-start">Prospects</h2>

    <div class="card crm-widget border-3 bg-body-tertiary text-body">
      <div class="card-body py-3 px-3">

        <!-- Fila 1 -->
        <div class="row g-3 mb-3">
          <div
              v-for="(item, index) in firstRow"
              :key="'row1-' + index"
              class="col-12 col-md-4"
          >
            <router-link :to="'/prospects/List?n=' + item.name" class="text-decoration-none">
              <div class="card w-100 h-100 border custom-card-border bg-body-tertiary text-body p-3 hover-scale">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <p class="text-uppercase mb-0 fw-bold fs-6" :style="{ color: item.colors }">
                    {{ item.name }}
                  </p>
                  <i :class="`${item.badge} fs-5 text-muted`"></i>
                </div>
                <div class="d-flex align-items-center">
                  <div class="avatar-sm bg-soft-primary rounded-circle d-flex align-items-center justify-content-center">
                    <i class="ri-user-add-line fs-3 text-primary"></i>
                  </div>
                  <div class="ms-3">
                    <h2 class="mb-0">
                      <count-to :startVal="0" :endVal="item.total" :duration="2000" />
                    </h2>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <!-- Fila 2 -->
        <div class="row g-3">
          <div
              v-for="(item, index) in secondRow"
              :key="'row2-' + index"
              class="col-12 col-md-4"
          >
            <router-link :to="'/prospects/List?n=' + item.name" class="text-decoration-none">
              <div class="card w-100 h-100 border custom-card-border bg-body-tertiary text-body p-3 hover-scale">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <p class="text-uppercase mb-0 fw-bold fs-6" :style="{ color: item.colors }">
                    {{ item.name }}
                  </p>
                  <i :class="`${item.badge} fs-5 text-muted`"></i>
                </div>
                <div class="d-flex align-items-center">
                  <div class="avatar-sm bg-soft-primary rounded-circle d-flex align-items-center justify-content-center">
                    <i class="ri-user-add-line fs-3 text-primary"></i>
                  </div>
                  <div class="ms-3">
                    <h2 class="mb-0">
                      <count-to :startVal="0" :endVal="item.total" :duration="2000" />
                    </h2>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <!-- Tarjeta vacía para balancear si hay solo 2 en fila -->
          <div v-if="secondRow.length === 2" class="col-12 col-md-4 d-none d-md-block"></div>
        </div>

        <!-- Estado vacío -->
        <div v-if="prospectsList[0]?.length === 0" class="text-center py-5">
          <lottie
              class="avatar-xl mx-auto mb-3"
              colors="primary:#121331,secondary:#08a88a"
              :options="defaultOptions"
              :height="75"
              :width="75"
          />
          <h6 class="mt-2 text-white">Sorry! No Result Found</h6>
        </div>

      </div>
    </div>
  </div>
</template>
